<template>
<CContainer>
    <CRow>
        <CCol col="12" class="d-flex overflow-auto px-0">
            <CreateBtn :to="{name: user.setup_status === UserSetupStatus.COMPLETE ? 'tickets.create' : 'setup.tickets.create'}" v-if="$policy('ticket').create"  class="mfe-2" />
            <FilterIt  class="mfe-2" />
            <SortIt class="min-w-fit-content mr-auto" />
        </CCol>
    </CRow>

    <Table class="mt-2" />
</CContainer>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import {Table, FilterIt, SortIt} from './partials'
import { UserSetupStatus } from '@/constants'

export default {
    name: 'List',

    components: {
        Table,
        FilterIt,
        SortIt
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchTickets()

            if (vm.$policy('ticket').create_any_or_group) {
                vm.fetchUsers({
                    no_paginate: true,
                    role: {
                        slug: 'operator'
                    }
                })
            }

            if (vm.$policy('ticket').select_responsible) {
                vm.fetchRoles({
                    no_paginate: true,
                    accesses: ['ticket.be_responsible']
                })
            }
        })
    },

    data() {
        return {
            UserSetupStatus
        }
    },

    computed: {
        ...mapGetters({
            user: 'user/current',
        })
    },

    methods: {
        ...mapActions({
            fetchRoles: 'role/fetch',
            fetchUsers: 'user/fetch',
            fetchTickets:'ticket/fetch',
        })
    },
}
</script>